"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countries = [
    {
        name: 'Afghanistan',
        alphaThree: 'AFG',
        countryCode: '004'
    },
    {
        name: 'Åland Islands',
        alphaThree: 'ALA',
        countryCode: '248'
    },
    {
        name: 'Albania',
        alphaThree: 'ALB',
        countryCode: '008'
    },
    {
        name: 'Algeria',
        alphaThree: 'DZA',
        countryCode: '012'
    },
    {
        name: 'American Samoa',
        alphaThree: 'ASM',
        countryCode: '016'
    },
    {
        name: 'Andorra',
        alphaThree: 'AND',
        countryCode: '020'
    },
    {
        name: 'Angola',
        alphaThree: 'AGO',
        countryCode: '024'
    },
    {
        name: 'Anguilla',
        alphaThree: 'AIA',
        countryCode: '660'
    },
    {
        name: 'Antarctica',
        alphaThree: 'ATA',
        countryCode: '010'
    },
    {
        name: 'Antigua and Barbuda',
        alphaThree: 'ATG',
        countryCode: '028'
    },
    {
        name: 'Argentina',
        alphaThree: 'ARG',
        countryCode: '032'
    },
    {
        name: 'Armenia',
        alphaThree: 'ARM',
        countryCode: '051'
    },
    {
        name: 'Aruba',
        alphaThree: 'ABW',
        countryCode: '533'
    },
    {
        name: 'Australia',
        alphaThree: 'AUS',
        countryCode: '036'
    },
    {
        name: 'Austria',
        alphaThree: 'AUT',
        countryCode: '040'
    },
    {
        name: 'Azerbaijan',
        alphaThree: 'AZE',
        countryCode: '031'
    },
    {
        name: 'Bahamas',
        alphaThree: 'BHS',
        countryCode: '044'
    },
    {
        name: 'Bahrain',
        alphaThree: 'BHR',
        countryCode: '048'
    },
    {
        name: 'Bangladesh',
        alphaThree: 'BGD',
        countryCode: '050'
    },
    {
        name: 'Barbados',
        alphaThree: 'BRB',
        countryCode: '052'
    },
    {
        name: 'Belarus',
        alphaThree: 'BLR',
        countryCode: '112'
    },
    {
        name: 'Belgium',
        alphaThree: 'BEL',
        countryCode: '056'
    },
    {
        name: 'Belize',
        alphaThree: 'BLZ',
        countryCode: '084'
    },
    {
        name: 'Benin',
        alphaThree: 'BEN',
        countryCode: '204'
    },
    {
        name: 'Bermuda',
        alphaThree: 'BMU',
        countryCode: '060'
    },
    {
        name: 'Bhutan',
        alphaThree: 'BTN',
        countryCode: '064'
    },
    {
        name: 'Bolivia (Plurinational State of)',
        alphaThree: 'BOL',
        countryCode: '068'
    },
    {
        name: 'Bonaire, Sint Eustatius and Saba',
        alphaThree: 'BES',
        countryCode: '535'
    },
    {
        name: 'Bosnia and Herzegovina',
        alphaThree: 'BIH',
        countryCode: '070'
    },
    {
        name: 'Botswana',
        alphaThree: 'BWA',
        countryCode: '072'
    },
    {
        name: 'Bouvet Island',
        alphaThree: 'BVT',
        countryCode: '074'
    },
    {
        name: 'Brazil',
        alphaThree: 'BRA',
        countryCode: '076'
    },
    {
        name: 'British Indian Ocean Territory',
        alphaThree: 'IOT',
        countryCode: '086'
    },
    {
        name: 'Brunei Darussalam',
        alphaThree: 'BRN',
        countryCode: '096'
    },
    {
        name: 'Bulgaria',
        alphaThree: 'BGR',
        countryCode: '100'
    },
    {
        name: 'Burkina Faso',
        alphaThree: 'BFA',
        countryCode: '854'
    },
    {
        name: 'Burundi',
        alphaThree: 'BDI',
        countryCode: '108'
    },
    {
        name: 'Cabo Verde',
        alphaThree: 'CPV',
        countryCode: '132'
    },
    {
        name: 'Cambodia',
        alphaThree: 'KHM',
        countryCode: '116'
    },
    {
        name: 'Cameroon',
        alphaThree: 'CMR',
        countryCode: '120'
    },
    {
        name: 'Canada',
        alphaThree: 'CAN',
        countryCode: '124'
    },
    {
        name: 'Cayman Islands',
        alphaThree: 'CYM',
        countryCode: '136'
    },
    {
        name: 'Central African Republic',
        alphaThree: 'CAF',
        countryCode: '140'
    },
    {
        name: 'Chad',
        alphaThree: 'TCD',
        countryCode: '148'
    },
    {
        name: 'Chile',
        alphaThree: 'CHL',
        countryCode: '152'
    },
    {
        name: 'China',
        alphaThree: 'CHN',
        countryCode: '156'
    },
    {
        name: 'Christmas Island',
        alphaThree: 'CXR',
        countryCode: '162'
    },
    {
        name: 'Cocos (Keeling) Islands',
        alphaThree: 'CCK',
        countryCode: '166'
    },
    {
        name: 'Colombia',
        alphaThree: 'COL',
        countryCode: '170'
    },
    {
        name: 'Comoros',
        alphaThree: 'COM',
        countryCode: '174'
    },
    {
        name: 'Congo',
        alphaThree: 'COG',
        countryCode: '178'
    },
    {
        name: 'Congo, Democratic Republic of the',
        alphaThree: 'COD',
        countryCode: '180'
    },
    {
        name: 'Cook Islands',
        alphaThree: 'COK',
        countryCode: '184'
    },
    {
        name: 'Costa Rica',
        alphaThree: 'CRI',
        countryCode: '188'
    },
    {
        name: "Côte d'Ivoire",
        alphaThree: 'CIV',
        countryCode: '384'
    },
    {
        name: 'Croatia',
        alphaThree: 'HRV',
        countryCode: '191'
    },
    {
        name: 'Cuba',
        alphaThree: 'CUB',
        countryCode: '192'
    },
    {
        name: 'Curaçao',
        alphaThree: 'CUW',
        countryCode: '531'
    },
    {
        name: 'Cyprus',
        alphaThree: 'CYP',
        countryCode: '196'
    },
    {
        name: 'Czechia',
        alphaThree: 'CZE',
        countryCode: '203'
    },
    {
        name: 'Denmark',
        alphaThree: 'DNK',
        countryCode: '208'
    },
    {
        name: 'Djibouti',
        alphaThree: 'DJI',
        countryCode: '262'
    },
    {
        name: 'Dominica',
        alphaThree: 'DMA',
        countryCode: '212'
    },
    {
        name: 'Dominican Republic',
        alphaThree: 'DOM',
        countryCode: '214'
    },
    {
        name: 'Ecuador',
        alphaThree: 'ECU',
        countryCode: '218'
    },
    {
        name: 'Egypt',
        alphaThree: 'EGY',
        countryCode: '818'
    },
    {
        name: 'El Salvador',
        alphaThree: 'SLV',
        countryCode: '222'
    },
    {
        name: 'Equatorial Guinea',
        alphaThree: 'GNQ',
        countryCode: '226'
    },
    {
        name: 'Eritrea',
        alphaThree: 'ERI',
        countryCode: '232'
    },
    {
        name: 'Estonia',
        alphaThree: 'EST',
        countryCode: '233'
    },
    {
        name: 'Eswatini',
        alphaThree: 'SWZ',
        countryCode: '748'
    },
    {
        name: 'Ethiopia',
        alphaThree: 'ETH',
        countryCode: '231'
    },
    {
        name: 'Falkland Islands (Malvinas)',
        alphaThree: 'FLK',
        countryCode: '238'
    },
    {
        name: 'Faroe Islands',
        alphaThree: 'FRO',
        countryCode: '234'
    },
    {
        name: 'Fiji',
        alphaThree: 'FJI',
        countryCode: '242'
    },
    {
        name: 'Finland',
        alphaThree: 'FIN',
        countryCode: '246'
    },
    {
        name: 'France',
        alphaThree: 'FRA',
        countryCode: '250'
    },
    {
        name: 'French Guiana',
        alphaThree: 'GUF',
        countryCode: '254'
    },
    {
        name: 'French Polynesia',
        alphaThree: 'PYF',
        countryCode: '258'
    },
    {
        name: 'French Southern Territories',
        alphaThree: 'ATF',
        countryCode: '260'
    },
    {
        name: 'Gabon',
        alphaThree: 'GAB',
        countryCode: '266'
    },
    {
        name: 'Gambia',
        alphaThree: 'GMB',
        countryCode: '270'
    },
    {
        name: 'Georgia',
        alphaThree: 'GEO',
        countryCode: '268'
    },
    {
        name: 'Germany',
        alphaThree: 'DEU',
        countryCode: '276'
    },
    {
        name: 'Ghana',
        alphaThree: 'GHA',
        countryCode: '288'
    },
    {
        name: 'Gibraltar',
        alphaThree: 'GIB',
        countryCode: '292'
    },
    {
        name: 'Greece',
        alphaThree: 'GRC',
        countryCode: '300'
    },
    {
        name: 'Greenland',
        alphaThree: 'GRL',
        countryCode: '304'
    },
    {
        name: 'Grenada',
        alphaThree: 'GRD',
        countryCode: '308'
    },
    {
        name: 'Guadeloupe',
        alphaThree: 'GLP',
        countryCode: '312'
    },
    {
        name: 'Guam',
        alphaThree: 'GUM',
        countryCode: '316'
    },
    {
        name: 'Guatemala',
        alphaThree: 'GTM',
        countryCode: '320'
    },
    {
        name: 'Guernsey',
        alphaThree: 'GGY',
        countryCode: '831'
    },
    {
        name: 'Guinea',
        alphaThree: 'GIN',
        countryCode: '324'
    },
    {
        name: 'Guinea-Bissau',
        alphaThree: 'GNB',
        countryCode: '624'
    },
    {
        name: 'Guyana',
        alphaThree: 'GUY',
        countryCode: '328'
    },
    {
        name: 'Haiti',
        alphaThree: 'HTI',
        countryCode: '332'
    },
    {
        name: 'Heard Island and McDonald Islands',
        alphaThree: 'HMD',
        countryCode: '334'
    },
    {
        name: 'Holy See',
        alphaThree: 'VAT',
        countryCode: '336'
    },
    {
        name: 'Honduras',
        alphaThree: 'HND',
        countryCode: '340'
    },
    {
        name: 'Hong Kong',
        alphaThree: 'HKG',
        countryCode: '344'
    },
    {
        name: 'Hungary',
        alphaThree: 'HUN',
        countryCode: '348'
    },
    {
        name: 'Iceland',
        alphaThree: 'ISL',
        countryCode: '352'
    },
    {
        name: 'India',
        alphaThree: 'IND',
        countryCode: '356'
    },
    {
        name: 'Indonesia',
        alphaThree: 'IDN',
        countryCode: '360'
    },
    {
        name: 'Iran (Islamic Republic of)',
        alphaThree: 'IRN',
        countryCode: '364'
    },
    {
        name: 'Iraq',
        alphaThree: 'IRQ',
        countryCode: '368'
    },
    {
        name: 'Ireland',
        alphaThree: 'IRL',
        countryCode: '372'
    },
    {
        name: 'Isle of Man',
        alphaThree: 'IMN',
        countryCode: '833'
    },
    {
        name: 'Israel',
        alphaThree: 'ISR',
        countryCode: '376'
    },
    {
        name: 'Italy',
        alphaThree: 'ITA',
        countryCode: '380'
    },
    {
        name: 'Jamaica',
        alphaThree: 'JAM',
        countryCode: '388'
    },
    {
        name: 'Japan',
        alphaThree: 'JPN',
        countryCode: '392'
    },
    {
        name: 'Jersey',
        alphaThree: 'JEY',
        countryCode: '832'
    },
    {
        name: 'Jordan',
        alphaThree: 'JOR',
        countryCode: '400'
    },
    {
        name: 'Kazakhstan',
        alphaThree: 'KAZ',
        countryCode: '398'
    },
    {
        name: 'Kenya',
        alphaThree: 'KEN',
        countryCode: '404'
    },
    {
        name: 'Kiribati',
        alphaThree: 'KIR',
        countryCode: '296'
    },
    {
        name: "Korea (Democratic People's Republic of)",
        alphaThree: 'PRK',
        countryCode: '408'
    },
    {
        name: 'Korea, Republic of',
        alphaThree: 'KOR',
        countryCode: '410'
    },
    {
        name: 'Kuwait',
        alphaThree: 'KWT',
        countryCode: '414'
    },
    {
        name: 'Kyrgyzstan',
        alphaThree: 'KGZ',
        countryCode: '417'
    },
    {
        name: "Lao People's Democratic Republic",
        alphaThree: 'LAO',
        countryCode: '418'
    },
    {
        name: 'Latvia',
        alphaThree: 'LVA',
        countryCode: '428'
    },
    {
        name: 'Lebanon',
        alphaThree: 'LBN',
        countryCode: '422'
    },
    {
        name: 'Lesotho',
        alphaThree: 'LSO',
        countryCode: '426'
    },
    {
        name: 'Liberia',
        alphaThree: 'LBR',
        countryCode: '430'
    },
    {
        name: 'Libya',
        alphaThree: 'LBY',
        countryCode: '434'
    },
    {
        name: 'Liechtenstein',
        alphaThree: 'LIE',
        countryCode: '438'
    },
    {
        name: 'Lithuania',
        alphaThree: 'LTU',
        countryCode: '440'
    },
    {
        name: 'Luxembourg',
        alphaThree: 'LUX',
        countryCode: '442'
    },
    {
        name: 'Macao',
        alphaThree: 'MAC',
        countryCode: '446'
    },
    {
        name: 'Madagascar',
        alphaThree: 'MDG',
        countryCode: '450'
    },
    {
        name: 'Malawi',
        alphaThree: 'MWI',
        countryCode: '454'
    },
    {
        name: 'Malaysia',
        alphaThree: 'MYS',
        countryCode: '458'
    },
    {
        name: 'Maldives',
        alphaThree: 'MDV',
        countryCode: '462'
    },
    {
        name: 'Mali',
        alphaThree: 'MLI',
        countryCode: '466'
    },
    {
        name: 'Malta',
        alphaThree: 'MLT',
        countryCode: '470'
    },
    {
        name: 'Marshall Islands',
        alphaThree: 'MHL',
        countryCode: '584'
    },
    {
        name: 'Martinique',
        alphaThree: 'MTQ',
        countryCode: '474'
    },
    {
        name: 'Mauritania',
        alphaThree: 'MRT',
        countryCode: '478'
    },
    {
        name: 'Mauritius',
        alphaThree: 'MUS',
        countryCode: '480'
    },
    {
        name: 'Mayotte',
        alphaThree: 'MYT',
        countryCode: '175'
    },
    {
        name: 'Mexico',
        alphaThree: 'MEX',
        countryCode: '484'
    },
    {
        name: 'Micronesia (Federated States of)',
        alphaThree: 'FSM',
        countryCode: '583'
    },
    {
        name: 'Moldova, Republic of',
        alphaThree: 'MDA',
        countryCode: '498'
    },
    {
        name: 'Monaco',
        alphaThree: 'MCO',
        countryCode: '492'
    },
    {
        name: 'Mongolia',
        alphaThree: 'MNG',
        countryCode: '496'
    },
    {
        name: 'Montenegro',
        alphaThree: 'MNE',
        countryCode: '499'
    },
    {
        name: 'Montserrat',
        alphaThree: 'MSR',
        countryCode: '500'
    },
    {
        name: 'Morocco',
        alphaThree: 'MAR',
        countryCode: '504'
    },
    {
        name: 'Mozambique',
        alphaThree: 'MOZ',
        countryCode: '508'
    },
    {
        name: 'Myanmar',
        alphaThree: 'MMR',
        countryCode: '104'
    },
    {
        name: 'Namibia',
        alphaThree: 'NAM',
        countryCode: '516'
    },
    {
        name: 'Nauru',
        alphaThree: 'NRU',
        countryCode: '520'
    },
    {
        name: 'Nepal',
        alphaThree: 'NPL',
        countryCode: '524'
    },
    {
        name: 'Netherlands',
        alphaThree: 'NLD',
        countryCode: '528'
    },
    {
        name: 'New Caledonia',
        alphaThree: 'NCL',
        countryCode: '540'
    },
    {
        name: 'New Zealand',
        alphaThree: 'NZL',
        countryCode: '554'
    },
    {
        name: 'Nicaragua',
        alphaThree: 'NIC',
        countryCode: '558'
    },
    {
        name: 'Niger',
        alphaThree: 'NER',
        countryCode: '562'
    },
    {
        name: 'Nigeria',
        alphaThree: 'NGA',
        countryCode: '566'
    },
    {
        name: 'Niue',
        alphaThree: 'NIU',
        countryCode: '570'
    },
    {
        name: 'Norfolk Island',
        alphaThree: 'NFK',
        countryCode: '574'
    },
    {
        name: 'North Macedonia',
        alphaThree: 'MKD',
        countryCode: '807'
    },
    {
        name: 'Northern Mariana Islands',
        alphaThree: 'MNP',
        countryCode: '580'
    },
    {
        name: 'Norway',
        alphaThree: 'NOR',
        countryCode: '578'
    },
    {
        name: 'Oman',
        alphaThree: 'OMN',
        countryCode: '512'
    },
    {
        name: 'Pakistan',
        alphaThree: 'PAK',
        countryCode: '586'
    },
    {
        name: 'Palau',
        alphaThree: 'PLW',
        countryCode: '585'
    },
    {
        name: 'Palestine, State of',
        alphaThree: 'PSE',
        countryCode: '275'
    },
    {
        name: 'Panama',
        alphaThree: 'PAN',
        countryCode: '591'
    },
    {
        name: 'Papua New Guinea',
        alphaThree: 'PNG',
        countryCode: '598'
    },
    {
        name: 'Paraguay',
        alphaThree: 'PRY',
        countryCode: '600'
    },
    {
        name: 'Peru',
        alphaThree: 'PER',
        countryCode: '604'
    },
    {
        name: 'Philippines',
        alphaThree: 'PHL',
        countryCode: '608'
    },
    {
        name: 'Pitcairn',
        alphaThree: 'PCN',
        countryCode: '612'
    },
    {
        name: 'Poland',
        alphaThree: 'POL',
        countryCode: '616'
    },
    {
        name: 'Portugal',
        alphaThree: 'PRT',
        countryCode: '620'
    },
    {
        name: 'Puerto Rico',
        alphaThree: 'PRI',
        countryCode: '630'
    },
    {
        name: 'Qatar',
        alphaThree: 'QAT',
        countryCode: '634'
    },
    {
        name: 'Réunion',
        alphaThree: 'REU',
        countryCode: '638'
    },
    {
        name: 'Romania',
        alphaThree: 'ROU',
        countryCode: '642'
    },
    {
        name: 'Russian Federation',
        alphaThree: 'RUS',
        countryCode: '643'
    },
    {
        name: 'Rwanda',
        alphaThree: 'RWA',
        countryCode: '646'
    },
    {
        name: 'Saint Barthélemy',
        alphaThree: 'BLM',
        countryCode: '652'
    },
    {
        name: 'Saint Helena, Ascension and Tristan da Cunha',
        alphaThree: 'SHN',
        countryCode: '654'
    },
    {
        name: 'Saint Kitts and Nevis',
        alphaThree: 'KNA',
        countryCode: '659'
    },
    {
        name: 'Saint Lucia',
        alphaThree: 'LCA',
        countryCode: '662'
    },
    {
        name: 'Saint Martin (French part)',
        alphaThree: 'MAF',
        countryCode: '663'
    },
    {
        name: 'Saint Pierre and Miquelon',
        alphaThree: 'SPM',
        countryCode: '666'
    },
    {
        name: 'Saint Vincent and the Grenadines',
        alphaThree: 'VCT',
        countryCode: '670'
    },
    {
        name: 'Samoa',
        alphaThree: 'WSM',
        countryCode: '882'
    },
    {
        name: 'San Marino',
        alphaThree: 'SMR',
        countryCode: '674'
    },
    {
        name: 'Sao Tome and Principe',
        alphaThree: 'STP',
        countryCode: '678'
    },
    {
        name: 'Saudi Arabia',
        alphaThree: 'SAU',
        countryCode: '682'
    },
    {
        name: 'Senegal',
        alphaThree: 'SEN',
        countryCode: '686'
    },
    {
        name: 'Serbia',
        alphaThree: 'SRB',
        countryCode: '688'
    },
    {
        name: 'Seychelles',
        alphaThree: 'SYC',
        countryCode: '690'
    },
    {
        name: 'Sierra Leone',
        alphaThree: 'SLE',
        countryCode: '694'
    },
    {
        name: 'Singapore',
        alphaThree: 'SGP',
        countryCode: '702'
    },
    {
        name: 'Sint Maarten (Dutch part)',
        alphaThree: 'SXM',
        countryCode: '534'
    },
    {
        name: 'Slovakia',
        alphaThree: 'SVK',
        countryCode: '703'
    },
    {
        name: 'Slovenia',
        alphaThree: 'SVN',
        countryCode: '705'
    },
    {
        name: 'Solomon Islands',
        alphaThree: 'SLB',
        countryCode: '090'
    },
    {
        name: 'Somalia',
        alphaThree: 'SOM',
        countryCode: '706'
    },
    {
        name: 'South Africa',
        alphaThree: 'ZAF',
        countryCode: '710'
    },
    {
        name: 'South Georgia and the South Sandwich Islands',
        alphaThree: 'SGS',
        countryCode: '239'
    },
    {
        name: 'South Sudan',
        alphaThree: 'SSD',
        countryCode: '728'
    },
    {
        name: 'Spain',
        alphaThree: 'ESP',
        countryCode: '724'
    },
    {
        name: 'Sri Lanka',
        alphaThree: 'LKA',
        countryCode: '144'
    },
    {
        name: 'Sudan',
        alphaThree: 'SDN',
        countryCode: '729'
    },
    {
        name: 'Suriname',
        alphaThree: 'SUR',
        countryCode: '740'
    },
    {
        name: 'Svalbard and Jan Mayen',
        alphaThree: 'SJM',
        countryCode: '744'
    },
    {
        name: 'Sweden',
        alphaThree: 'SWE',
        countryCode: '752'
    },
    {
        name: 'Switzerland',
        alphaThree: 'CHE',
        countryCode: '756'
    },
    {
        name: 'Syrian Arab Republic',
        alphaThree: 'SYR',
        countryCode: '760'
    },
    {
        name: 'Taiwan, Province of China',
        alphaThree: 'TWN',
        countryCode: '158'
    },
    {
        name: 'Tajikistan',
        alphaThree: 'TJK',
        countryCode: '762'
    },
    {
        name: 'Tanzania, United Republic of',
        alphaThree: 'TZA',
        countryCode: '834'
    },
    {
        name: 'Thailand',
        alphaThree: 'THA',
        countryCode: '764'
    },
    {
        name: 'Timor-Leste',
        alphaThree: 'TLS',
        countryCode: '626'
    },
    {
        name: 'Togo',
        alphaThree: 'TGO',
        countryCode: '768'
    },
    {
        name: 'Tokelau',
        alphaThree: 'TKL',
        countryCode: '772'
    },
    {
        name: 'Tonga',
        alphaThree: 'TON',
        countryCode: '776'
    },
    {
        name: 'Trinidad and Tobago',
        alphaThree: 'TTO',
        countryCode: '780'
    },
    {
        name: 'Tunisia',
        alphaThree: 'TUN',
        countryCode: '788'
    },
    {
        name: 'Turkey',
        alphaThree: 'TUR',
        countryCode: '792'
    },
    {
        name: 'Turkmenistan',
        alphaThree: 'TKM',
        countryCode: '795'
    },
    {
        name: 'Turks and Caicos Islands',
        alphaThree: 'TCA',
        countryCode: '796'
    },
    {
        name: 'Tuvalu',
        alphaThree: 'TUV',
        countryCode: '798'
    },
    {
        name: 'Uganda',
        alphaThree: 'UGA',
        countryCode: '800'
    },
    {
        name: 'Ukraine',
        alphaThree: 'UKR',
        countryCode: '804'
    },
    {
        name: 'United Arab Emirates',
        alphaThree: 'ARE',
        countryCode: '784'
    },
    {
        name: 'United Kingdom of Great Britain and Northern Ireland',
        alphaThree: 'GBR',
        countryCode: '826'
    },
    {
        name: 'United States of America',
        alphaThree: 'USA',
        countryCode: '840'
    },
    {
        name: 'United States Minor Outlying Islands',
        alphaThree: 'UMI',
        countryCode: '581'
    },
    {
        name: 'Uruguay',
        alphaThree: 'URY',
        countryCode: '858'
    },
    {
        name: 'Uzbekistan',
        alphaThree: 'UZB',
        countryCode: '860'
    },
    {
        name: 'Vanuatu',
        alphaThree: 'VUT',
        countryCode: '548'
    },
    {
        name: 'Venezuela (Bolivarian Republic of)',
        alphaThree: 'VEN',
        countryCode: '862'
    },
    {
        name: 'Viet Nam',
        alphaThree: 'VNM',
        countryCode: '704'
    },
    {
        name: 'Virgin Islands (British)',
        alphaThree: 'VGB',
        countryCode: '092'
    },
    {
        name: 'Virgin Islands (U.S.)',
        alphaThree: 'VIR',
        countryCode: '850'
    },
    {
        name: 'Wallis and Futuna',
        alphaThree: 'WLF',
        countryCode: '876'
    },
    {
        name: 'Western Sahara',
        alphaThree: 'ESH',
        countryCode: '732'
    },
    {
        name: 'Yemen',
        alphaThree: 'YEM',
        countryCode: '887'
    },
    {
        name: 'Zambia',
        alphaThree: 'ZMB',
        countryCode: '894'
    },
    {
        name: 'Zimbabwe',
        alphaThree: 'ZWE',
        countryCode: '716'
    }
];
//# sourceMappingURL=countries.js.map